var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#B558F6",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9282 11.5133L19.6033 12.8381L23.1619 16.3967L24.4867 15.0718C25.1711 14.3875 25.1711 13.2788 24.4867 12.5945L23.4082 11.5133C22.7239 10.8289 21.6153 10.8289 20.9309 11.5133H20.9282ZM18.9847 13.4568L12.6039 19.8403C12.3192 20.125 12.1112 20.4781 11.9962 20.864L11.0272 24.1571C10.9587 24.3898 11.0217 24.6389 11.1914 24.8086C11.3611 24.9783 11.6102 25.0412 11.8402 24.9756L15.1332 24.0065C15.5192 23.8916 15.8723 23.6835 16.157 23.3988L22.5432 17.0153L18.9847 13.4568Z",
    fill: "#B558F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.c284eed4aec8a676287a9e00d5a0e84f.svg";
export { ForwardRef as ReactComponent };